export const API_URL = 'https://sushitime47.ru/api/'